import { Button, Form } from '@visionplanner/ui-react-material';
import { useContext } from 'react';
import isEqual from 'lodash.isequal';
import { SalesOnBoarding } from '../sales.context';
import { useAsyncCallback } from '../../../common/custom-hooks/use-async-callback';
import { invoicingInformationFormSchema } from './sales-form-validation';
import { StyledModalFooter } from '../../styles';
import { InvoicingForm } from './invoicing-form';
import { saveInvoicingInformation } from '../sales-onboarding-partner.request';
import { types } from '../sales-onboarding-partner.reducer';

const InvoiceInformation = ({ invoiceTypes }) => {
  const {
    setActiveStep,
    activeStep,
    dispatch,
    state,
  } = useContext(SalesOnBoarding);

  const handleSubmit = useAsyncCallback(async (formValues, { setSubmitting }) => {
    try {
      if (!isEqual(state.invoicingInformation, formValues)) {
        const { lastModified } = await saveInvoicingInformation(state.partnerId, formValues);
        dispatch({
          type: types.updateInvoicingInformation,
          payload: { lastModified, formValues },
        });
      }
      setActiveStep(activeStep + 1);
    } finally {
      setSubmitting(false);
    }
  }, [activeStep, dispatch, setActiveStep, state.invoicingInformation, state.partnerId]);

  return (
    <>
      <Form
        initialValues={state.invoicingInformation}
        validateFormSchema={invoicingInformationFormSchema}
        onSubmit={handleSubmit}
        isInitiallyValid={invoicingInformationFormSchema.isValidSync(state.invoicingInformation)}
        dataTa="invoicing-information-form"
        className="full-height form-inline flex-column overflow-hidden"
      >
        {({
          values, isValid, isSubmitting,
        }) => (
          <>
            <InvoicingForm values={values} invoiceTypes={invoiceTypes} />
            <StyledModalFooter>
              <Button buttonType="secondary" dataTa="go-to-onboarding-information" onClick={() => setActiveStep(activeStep - 1)}>Vorige</Button>
              <Button type="submit" dataTa="go-to-review-step" disabled={!isValid || isSubmitting}>Volgende</Button>
            </StyledModalFooter>
          </>
        )}
      </Form>
    </>
  );
};

export default InvoiceInformation;
